import { Controller, useFormContext } from 'react-hook-form';
import { BaseOption } from 'ui/selects';
import { localizeDateTime } from 'utils/l10n';
import { Cell, StyledFormField, StyledSelect } from './Table.styled';

type EffectiveDateCellProps = {
  name: string;
  options: BaseOption<string>[];
};

export const EffectiveDateCell = ({ name, options }: EffectiveDateCellProps) => {
  const { watch } = useFormContext();
  const effectiveDate = watch(name);

  /** Create a Custom option for dates that are not included in the options API call */
  const customOptions = options.map((option) => option.value).includes(effectiveDate)
    ? options
    : [
        ...options,
        {
          description: localizeDateTime(new Date(parseInt(effectiveDate, 10))),
          label: 'Custom',
          value: new Date(parseInt(effectiveDate, 10)).getTime().toString(),
        },
      ];

  return (
    <Cell>
      <Controller
        name={name}
        render={({ field: { onChange }, fieldState: { error } }) => {
          const selectedDate = customOptions.find((op) => effectiveDate === op.value);
          const errorMessage = error?.message;

          return (
            <StyledFormField
              data-test="effective-date-form-field"
              hasError={!!errorMessage}
              errorText={errorMessage}
            >
              <StyledSelect
                isMulti={false}
                menuPlacement="auto"
                options={customOptions}
                onSelect={([option]) => onChange(option.value)}
                usePortal
                value={[selectedDate]}
              />
            </StyledFormField>
          );
        }}
      />
    </Cell>
  );
};
